// Laboratory documentation: https://product.hubteam.com/docs/laboratory/guides/coding-a-frontend-experiment.html

import { createClient } from 'laboratory-lib';
import portalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
import experiments from '../../experiments.yaml';
import { getDeviceId, getUtk } from 'usage-tracker-core/common/defaultTrackers';
import { isIndexedDBSupported } from './isIndexedDBSupported';
const identifiers = {
  portalId: portalIdParser.get(),
  other: getDeviceId(),
  utk: getUtk()
};

// YAML imports don't carry ExperimentSchemas type — isolated cast per §18.
const typedExperiments = experiments;

// When IndexedDB is unavailable (headless crawlers), passing `store: null` makes
// laboratory-lib use an in-memory mock store instead of the default IndexedDB
// SuperStore, which would otherwise reject with an unhandled
// "IndexedDB is not supported in this environment." error.
const store = isIndexedDBSupported() ? undefined : null;
function createWithQuickFetch() {
  return createClient({
    name: 'pricing-pages-public-client',
    quickFetchLabel: 'experiment-treatments',
    identifiers,
    experiments: typedExperiments,
    store
  });
}
function createWithoutQuickFetch() {
  return createClient({
    name: 'pricing-pages-public-client',
    identifiers,
    experiments: typedExperiments,
    store
  });
}
function buildLaboratoryClient() {
  try {
    return createWithQuickFetch();
  } catch (quickFetchError) {
    Raven.captureException(quickFetchError instanceof Error ? quickFetchError : new Error(String(quickFetchError)), {
      level: 'warning'
    });
    try {
      return createWithoutQuickFetch();
    } catch (fallbackError) {
      Raven.captureException(fallbackError instanceof Error ? fallbackError : new Error(String(fallbackError)));
      throw fallbackError;
    }
  }
}
export const laboratoryClient = buildLaboratoryClient();
export const logExposure = treatmentKey => laboratoryClient.logExposure(treatmentKey);